import React, { useState, useCallback, useEffect } from "react";
import ExperienceItem from "../../steps/ProfessionalExperience/ExperienceItem";
import { useDispatch } from 'react-redux';
import { showModal } from '../../../../redux/system/actions';
import ConfirmModal from "../../../common/modals/ConfirmModal";
import ExperienceForm from "../../steps/ProfessionalExperience/ExperienceForm";

const CONFIRM_MODAL_ID = 'confirmModal';

function ExperienceMainMenu({ curriculumVitae, handleSaveItem, handleDeleteItem, status }) {
    const dispatch = useDispatch();
    const handleShowModal = useCallback((modalId) => dispatch(showModal(modalId)), [dispatch]);

    const [experiences, setExperiences] = useState(curriculumVitae.curriculumVitaeExperiences || []);
    const [experienceToDelete, setExperienceToDelete] = useState(null);
    const [editingExperience, setEditingExperience] = useState(null);
    const [addingExperience, setAddingExperience] = useState(false);

    useEffect(() => {
        setExperiences(curriculumVitae.curriculumVitaeExperiences || []);
    }, [curriculumVitae.curriculumVitaeExperiences]);

    const confirmDeleteExperience = async (experienceId) => {
        setExperienceToDelete(experienceId);
        handleShowModal(CONFIRM_MODAL_ID);
    };

    const handleSave = async (itemData, type) => {
        setAddingExperience(false);
        handleSaveItem(itemData, type);
    }

    return (
        <div className="cv-main-menu-overview">
            {(editingExperience || addingExperience) ? (
                <>
                    <h3 className="cv-main-menu-edit-mode">
                        {editingExperience ? 'Edit Mode' : 'Add Work Experience'}
                    </h3>
                    <div className="main-menu-form-wrapper">
                    <ExperienceForm
                        curriculumVitaeId={curriculumVitae.id}
                        initialExperience={editingExperience}
                        setEditingExperience={setEditingExperience}
                        setAddingExperience={setAddingExperience}
                        onSave={(experienceData) => handleSave(experienceData, 'curriculumVitaeExperiences')}
                        status={status}
                        />
                    </div>
                </>
            ) : (
                <>
                <div className="cv-main-menu-list">
                    <ul>
                        {curriculumVitae.curriculumVitaeExperiences
                            .slice()
                            .sort((a, b) => {
                                const dateA = a.currentJob ? new Date() : new Date(a.endDate);
                                const dateB = b.currentJob ? new Date() : new Date(b.endDate);
                                
                                return dateB - dateA;
                            })
                            .map((experience) => (
                                <div key={experience.id} className="main-menu-item-wrapper">
                                    <ExperienceItem
                                        experience={experience}
                                        onEdit={() => setEditingExperience(experience)}
                                        onDelete={() => confirmDeleteExperience(experience.id)}
                                    />
                                </div>
                            ))}
                    </ul>
                </div>
                    <button className="cv-main-menu-add" onClick={() => setAddingExperience(true)}>
                        <i className="pe-7s-plus mr-2"></i>
                        Add another work experience
                    </button>
                </>
            )}

            <ConfirmModal
                id={CONFIRM_MODAL_ID}
                title="Are you sure you want to delete this professional experience?"
                message="This will permanently remove the selected experience from your profile. Do you wish to proceed?"
                onConfirm={() => handleDeleteItem(experienceToDelete, 'curriculumVitaeExperiences')}
            />
        </div>
    );
}

export default ExperienceMainMenu;
